import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Page} from '../../../core/pagination/page';
import {Client} from '../../client';
import {Zone} from '../../../zone/zone';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {ClientenFilter} from '../filter/clienten-filter';
import {ClientPageRequest} from '../../client-page-request';
import {Diensten} from '../../../dienst/diensten';

@Component({
    selector: 'zah-clienten-overzicht-regioverantwoordelijke',
    templateUrl: './clienten-overzicht-regioverantwoordelijke.component.html',
    styleUrls: ['./clienten-overzicht-regioverantwoordelijke.component.scss'],
    standalone: false
})
export class ClientenOverzichtRegioverantwoordelijkeComponent implements OnInit {

  @Input()
  initialPageRequest: ClientPageRequest;
  @Input()
  clientenPage: Page<Client>;
  @Input()
  zones: Array<Zone>;
  @Input()
  diensten: Diensten;
  @Output()
  clientClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  meldingenClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  prestatiesClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  signaalkaartenClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  wijzigClientClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  clientFicheClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  archiveClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  unarchiveClicked: EventEmitter<Client> = new EventEmitter<Client>();
  @Output()
  addClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  pageChange: EventEmitter<ClientPageRequest> = new EventEmitter<ClientPageRequest>();

  private currentPageRequest: ClientPageRequest;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onClientClick(client: Client): void {
    this.clientClicked.emit(client);
  }

  onMeldingenClicked(client: Client): void {
    this.meldingenClicked.emit(client);
  }

  onPrestatiesClick(client: Client): void {
    this.prestatiesClicked.emit(client);
  }

  onSignaalkaartenClick(client: Client): void {
    this.signaalkaartenClicked.emit(client);
  }

  onWijzigClientClick(client: Client): void {
    this.wijzigClientClicked.emit(client);
  }

  onClientFicheClick(client: Client): void {
    this.clientFicheClicked.emit(client);
  }

  onArchiveClick(client: Client): void {
    this.archiveClicked.emit(client);
  }

  onUnarchiveClick(client: Client): void {
    this.unarchiveClicked.emit(client);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = this.currentPageRequest.withSortOrder(sortOrder);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = this.currentPageRequest.withPageSize(pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Client>): void {
    this.currentPageRequest = this.currentPageRequest.forPageRequest(pageRequest);
    this.pageChange.emit(this.currentPageRequest);
  }

  onSearch(clientenFilter: ClientenFilter): void {
    this.currentPageRequest = ClientPageRequest.clientFilterRequest(clientenFilter, this.currentPageRequest);
    this.pageChange.emit(this.currentPageRequest);
  }
}
